<script setup lang="ts">
// 배포 후 stale chunk 감지 시(appUpdate.updateAvailable) 하단 중앙에 새로고침 안내 토스트.
import { updateAvailable } from "../utils/appUpdate";

function reload() {
  window.location.reload();
}
</script>

<template>
  <div v-if="updateAvailable" class="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] px-2 w-full max-w-md">
    <div class="alert bg-indigo-600 text-white shadow-lg flex items-center justify-between gap-3">
      <span class="text-sm font-medium">업데이트가 있습니다. 새로고침 해주세요.</span>
      <button class="btn btn-sm bg-white text-indigo-600 hover:bg-indigo-50 border-none shrink-0" @click="reload">
        새로고침
      </button>
    </div>
  </div>
</template>
